<div class="job-layer-list-wrapper">

    <preopen-accordion
        [header]="'TC.Common.Features'"
        [useModusIcons]="true"
        [initialMaxHeight]="'175px'"
        (expandStateChange)="($event)"
    >
        <ng-container accordionActions *ngIf="isFeaturesAvailable">
            <ng-container *ngFor="let action of accordionActions">
                <button
                    *ngIf="action.title"
                    class="toggle-button"
                    (click)="onActionClick(action)"
                >
                    {{ action.title | translate }}
                </button>
                <button
                    *ngIf="action.icon"
                    class="toggle-button use-modus-icons"
                    (click)="onActionClick(action)"
                    [title]="action.tooltipKey ? (action.tooltipKey | translate) : ''"
                >
                    <i class="modus-icons" aria-hidden="true">{{ action.icon }}</i>
                </button>
            </ng-container>
        </ng-container>
        <div class="job-layer-list-content">
                <ng-container *ngIf="jobFeatureDetails; else loading">
                    <ng-container *ngIf="jobFeatureDetails.layers.length > 0; else noFeatures">
                        <div *ngFor="let layer of jobFeatureDetails.layers" class="layer-item">
                            <div class="layer-icon">
                                <geom-icon
                                    path="symbol_24-preview-"
                                    [color]="layer.layerColor"
                                    [outlineColor]="getOutlineColorFromStyle(layer)"
                                    [svgIcon]="layer.style.symbol?.svgImage"
                                    [symbolType]="layer.style.symbol?.type"
                                    [symbolText]="layer.style.symbol?.text"
                                    [lineStyle]="layer.style.lineStyle"
                                    [polygonOpacity]="layer.style.fillOpacity"
                                    [geoType]="layer.geomType"
                                ></geom-icon>
                            </div>
                            <h5 class="layer-name">{{ layer.name }}</h5>
                            <span class="features-count">{{ layer.count }} features</span>
                        </div>
                    </ng-container>
                    <ng-template #noFeatures>
                        <div class="no-data-label no-features">{{"Survey.SurveyDeatilPanel.NoFeature" | translate}}</div>
                    </ng-template>
                </ng-container>
                <ng-template #loading>
                    <loading />
                </ng-template>
            </div>
    </preopen-accordion>
</div>
